import { createContext, useContext, useEffect, useState } from "react";
import { loginRequest, verifyTokenRequest, logoutRequest } from '../api/auth.js'
import Cookies from 'js-cookie'

export const AuthContext = createContext()

export const useAuth = () => {
    const context = useContext(AuthContext)
    if(!context) throw new Error("useAuth must be used within an AuthProvider")

    return context
}

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingLogin, setLoadingLogin] = useState(false)

    useEffect(() => {
        if(errors.length > 0 || errors.message) {
            const timer = setTimeout(() => {
                setErrors([])
            }, 5000)
            return () => clearTimeout(timer)
        }
    }, [errors])

    useEffect(() => {
        async function checkLogin () {
            const cookies = Cookies.get()

            if(!cookies.token) {
                setIsAuthenticated(false)
                setUser(null)
            } else {
                try {
                    const res = await verifyTokenRequest()
                    if(!res.data) {
                        setIsAuthenticated(false)
                        setUser(null)
                        return;
                    }

                    setIsAuthenticated(true)
                    setUser(res.data)
                } catch(error) {
                    setIsAuthenticated(false)
                    setUser(null)
                }
            }
            setLoading(false)
        }

        checkLogin()
    }, [])

    const signIn = async (user) => {
        setLoadingLogin(true)
        try {
            const res = await loginRequest(user)
            setUser(res.data)
            setIsAuthenticated(true)
        } catch(error) {
            if(error.code === "ERR_NETWORK") {
                setErrors([{message: error.message}])
            } else {
                setErrors(error.response.data)
            }
        }
        setLoadingLogin(false)
    }

    const logOut = async () => {
        const res = await logoutRequest()
        setIsAuthenticated(false)
        setUser(null)
    }

    const clearErrors = () => setErrors([])

    return(
        <AuthContext.Provider value={{signIn, user, isAuthenticated, errors, clearErrors, loading, loadingLogin, logOut}}>
            {children}
        </AuthContext.Provider>
    )
}